import { render } from "./Feed.vue?vue&type=template&id=137ef61e&lang=pug"
import script from "./Feed.vue?vue&type=script&lang=js"
export * from "./Feed.vue?vue&type=script&lang=js"

import "./Feed.vue?vue&type=style&index=0&id=137ef61e&lang=sass"

import exportComponent from "/Users/adolforeyna/Projects/EMI/website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__